import * as z from "zod/v4";

export const startShipStationApiSync = {
  name: "startShipStationApiSync" as const,
  input: z.object({}),
  output: z.object({ workflowId: z.string() }),
};
